import { ChevronDown } from 'lucide-react';

/**
 * A bordered, expandable option card: icon + title + description in the
 * header, an optional status badge, and a collapsible content area below.
 * Generic enough to represent any "pick one of several config options"
 * surface (payment methods, notification channels, etc) — not tied to any
 * one domain.
 */
export default function SelectableCard({ icon: Icon, title, description, badge, expanded, onToggle, children }) {
	return (
		<div className='border border-gray-200 rounded-lg overflow-hidden'>
			<button
				type='button'
				onClick={onToggle}
				className='w-full flex items-start gap-3 px-4 py-3 text-left hover:bg-gray-50'
			>
				{Icon && (
					<div className='shrink-0 mt-0.5 flex items-center justify-center size-8 rounded-full bg-gray-100 text-gray-600'>
						<Icon className='size-4' />
					</div>
				)}
				<div className='flex-1 min-w-0'>
					<div className='flex items-center gap-2 flex-wrap'>
						<span className='font-medium text-sm'>{title}</span>
						{badge}
					</div>
					{description && <p className='text-sm text-gray-500 mt-0.5'>{description}</p>}
				</div>
				<ChevronDown
					className={`size-4 shrink-0 mt-1 text-gray-400 transition-transform ${expanded ? 'rotate-180' : ''}`}
				/>
			</button>
			{expanded && <div className='border-t border-gray-200 px-4 py-4 bg-gray-50/50'>{children}</div>}
		</div>
	);
}
